import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { DialogComponent } from '../dialog/dialog.component';

import { ButtonDirective } from 'shared/directive/button.directive';
import { AuthBaseService } from 'shared/services/auth-base.service';

@Component({
	selector: 'app-session-dialog',
	templateUrl: './session-dialog.component.html',
	styleUrl: './session-dialog.component.scss',
	standalone: true,
	imports: [DialogComponent, MatButtonModule, ButtonDirective, MatDialogModule, TranslateModule],
})
export class SessionDialogComponent {
	constructor(private authBaseService: AuthBaseService) {}

	async keepSessionAlive() {
		await this.authBaseService.keepSessionAlive();
	}
}
